<template>
  <div>
    <player-breadcrumb
      class="mb-2"
      :view="$t('player_profile.wellness')"
      :player="player"
    />
    <today-wellness
      :stats="todayStats"
      :loading="player.loading"
      :gender="player.data.gender"
    />
    <v-row
      align="center"
      class="mt-2"
    >
      <v-col>
        <div class="title">
          {{ $t("wellness.history") }}
        </div>
      </v-col>
      <v-col cols="auto">
        <date-selector
          v-model="date"
          :label="$t('picker.date.title')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <player-sleep-status-chart
          :stats="playerStats.data"
          style="height: 450px"
        />
      </v-col>
      <v-col cols="12">
        <player-mood-stress-chart
          :stats="playerStats.data"
          style="height: 450px"
        />
      </v-col>
      <v-col cols="12">
        <player-general-muscle-soreness-chart
          :stats="playerStats.data"
          style="height: 450px"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import dayjs from 'dayjs'
import { PlayerApiService } from '@/data/services'
import { getColorForValue, processMaxValues } from '@/utils/helpers'
import PlayerBreadcrumb from '@/components/players/PlayerBreadcrumb.vue'
import { RouteNames } from '@/router/routes'
import TodayWellness from '@/components/wellness/TodayWellness.vue'
import DateSelector from '@/components/DateSelector.vue'
import PlayerSleepStatusChart from '@/components/charts/implementation/PlayerSleepStatusChart.vue'
import PlayerMoodStressChart from '@/components/charts/implementation/PlayerMoodStressChart.vue'
import PlayerGeneralMuscleSorenessChart from '@/components/charts/implementation/PlayerGeneralMuscleSorenessChart.vue'

export default {
  name: 'PlayerWellnessView',
  components: {
    PlayerGeneralMuscleSorenessChart,
    PlayerMoodStressChart,
    PlayerSleepStatusChart,
    DateSelector,
    TodayWellness,
    PlayerBreadcrumb
},
  data: () => ({
    player: {
      data: {},
      loading: false
    },
    playerStats: {
      data: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 14
      },
      maxValues: {},
      loading: false
    },
    dateMenu: false,
    date: null
  }),
  computed: {
    RouteNames() {
      return RouteNames
    },
    todayStats() {
      return this.player.data.latest_stats ? this.player.data.latest_stats : {}
    }
  },
  watch: {
    date() {
      if (this.date) {
        this.fetchPlayerStats()
      }
    }
  },
  created() {
    this.date = this.$dayjs()
    this.fetchPlayerDetails()
    this.fetchPlayerStats()
  },
  methods: {
    getColorForValue,
    async fetchPlayerDetails() {
      try {
        this.player.loading = true

        const resp = await PlayerApiService.getPlayerDetails(this.$route.params.id)
        this.player.data = resp.data

        this.player.data.latest_stats = {
          ...this.player.data.latest_stats,
          SLD: this.player.data.latest_stats?.SLD ? (this.player.data.latest_stats?.SLD / 60).toFixed(2) : null,
          FAT_perc: (((6 - this.player.data.latest_stats?.FAT || 0) / 5) * 100).toFixed(0),
          GMS_perc: (((6 - this.player.data.latest_stats?.GMS || 0) / 5) * 100).toFixed(0),
          MOO_perc: ((this.player.data.latest_stats?.MOO || 0 / 5) * 100).toFixed(0),
          STL_perc: (((6 - this.player.data.latest_stats?.STL || 0) / 5) * 100).toFixed(0)
        }
      } catch (e) {
        // todo
      } finally {
        this.player.loading = false
      }
    },
    async fetchPlayerStats() {
      try {
        this.playerStats.loading = true

        const queryParams = {}

        if (this.date) {
          queryParams.date_from = dayjs(this.date).subtract(14, 'days').format('YYYY-MM-DD')
          queryParams.date_to = dayjs(this.date).format('YYYY-MM-DD')
        }

        const resp = await PlayerApiService.getStats(this.$route.params.id, queryParams)

        this.playerStats.maxValues = processMaxValues(resp.data.map(stat => stat.stats))

        this.playerStats.data = resp.data.map(stat => {
          if (!stat.stats) {
            return stat
          }

          if (stat.stats.SLD) stat.stats.SLD = (stat.stats.SLD / 60).toFixed(2)

          if (stat.stats.FAT) stat.stats.FAT_perc = (((6 - stat.stats.FAT) / 5) * 100).toFixed(0)
          if (stat.stats.GMS) stat.stats.GMS_perc = (((6 - stat.stats.GMS) / 5) * 100).toFixed(0)
          if (stat.stats.MOO) stat.stats.MOO_perc = ((stat.stats.MOO / 5) * 100).toFixed(0)
          if (stat.stats.STL) stat.stats.STL_perc = (((6 - stat.stats.STL) / 5) * 100).toFixed(0)

          return stat
        })

        this.playerStats.pagination = resp.meta
      } catch (e) {
        // todo
      } finally {
        this.playerStats.loading = false
      }
    }
  }
}
</script>

<style>

</style>
